import DialogCreateCategorySetttings from "@components/Dialog/CreateCategorySettings";
import { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { createCategory, editCategory, getCategories, inactivateCategory } from "@services/form";
import { useIntl } from "react-intl";
import { ICategoryResponse } from "@types";
import { useT, useLocalizedName } from "@hooks";
import SettingsCrudPage from "../SettingsCrudPage";
import useSettingsCrudPage from "../useSettingsCrudPage";

const defaultColumnOrder = ["name", "type", "expenseType"];

const CategoriesPage = () => {
  const t = useT();
  const localizedName = useLocalizedName();
  const { locale } = useIntl();

  const crud = useSettingsCrudPage({
    translationPrefix: "settings.category",
    reloadKey: locale,
    fetchService: getCategories,
    mountOption: (data: ICategoryResponse[]) =>
      data?.map((res) => ({
        id: res.id,
        name: localizedName(res),
        date: "",
        type: res.type,
        expenseType: res.expenseType || "",
        active: res?.active,
        predefined: res.predefined,
      })),
    createService: (value, selectCategory, selectType) =>
      createCategory({
        name: value,
        type: selectType as "RECEITA" | "DESPESA",
        expenseType: selectCategory as "DIRETO" | "OPERACIONAL",
      }),
    editService: (selected, value, selectCategory, selectType) =>
      editCategory({
        id: selected.id,
        name: value,
        type: selectType as "RECEITA" | "DESPESA",
        expenseType: selectCategory as "DIRETO" | "OPERACIONAL",
      }),
    inactivateService: inactivateCategory,
    buildEditSelection: (id: number, name: string, type?: string, expenseType?: string) => ({
      id,
      name,
      type,
      expenseType,
    }),
  });

  const columnLabels: ColumnLabel = {
    id: "1",
    name: t("settings.category.column.name"),
    type: t("settings.category.column.type"),
    expenseType: t("settings.category.column.expenseType"),
    date: "",
  };

  return (
    <SettingsCrudPage
      crud={crud}
      translationPrefix="settings.category"
      columnLabels={columnLabels}
      defaultColumnOrder={defaultColumnOrder}
    >
      <DialogCreateCategorySetttings
        title={t("settings.category.dialog.newTitle")}
        show={crud.createNewModal}
        placeholder={t("settings.category.placeholder.new")}
        onClose={() => {
          crud.setCreateNewModal(false);
        }}
        onSave={crud.handleSaveNewOption}
        showDuplicateAlert={crud.showDuplicateAlert}
        duplicateAlertMessage={crud.duplicateAlertMessage}
        existingNames={crud.options.map((o) => o.name)}
        duplicateNameMessage={t("settings.category.notification.createDuplicate")}
      />

      <DialogCreateCategorySetttings
        title={t("settings.category.dialog.editTitle")}
        show={crud.editModal}
        placeholder={t("settings.category.placeholder.edit")}
        onClose={() => {
          crud.setEditModal(false);
        }}
        onSave={(value: string, selectCategory?: string, selectType?: string) =>
          crud.handleEditOption(value, selectCategory, selectType)
        }
        name={crud.optionSelected?.name}
        type={crud.optionSelected?.type}
        expenseType={crud.optionSelected?.expenseType}
      />
    </SettingsCrudPage>
  );
};

export default CategoriesPage;
